export const BOOKING_HISTORY_CHANGES_DEFAULT_PAGE_SIZE = 500;
